import { render, staticRenderFns } from "./effectMarketForm.vue?vue&type=template&id=e9968f36&scoped=true"
import script from "./effectMarketForm.vue?vue&type=script&lang=js"
export * from "./effectMarketForm.vue?vue&type=script&lang=js"
import style0 from "./effectMarketForm.vue?vue&type=style&index=0&id=e9968f36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9968f36",
  null
  
)

export default component.exports